import type * as api from '@gitbook/api-client';
import { Dialog, DialogHeader, Heading } from '@gitbook/spine-react';

import { ContentSourceOpenAPIForm } from './ContentSourceOpenAPIForm';

interface CreateContentSourceOpenAPIDialogProps {
    organizationId: string;
    onSubmit: (computed: api.ComputedContentSourceRevisionOpenAPI) => void;
}

export function CreateContentSourceOpenAPIDialog(props: CreateContentSourceOpenAPIDialogProps) {
    return (
        <Dialog>
            <DialogHeader>
                <Heading>Insert OpenAPI Reference</Heading>
            </DialogHeader>
            <ContentSourceOpenAPIForm
                organizationId={props.organizationId}
                defaultValues={{
                    models: true,
                    specSlug: null,
                    downloadLink: true,
                }}
                onSubmit={props.onSubmit}
                buttonLabel="Insert"
            />
        </Dialog>
    );
}
